import { render } from "./UserMaster.vue?vue&type=template&id=064b79de"
import script from "./UserMaster.vue?vue&type=script&lang=js"
export * from "./UserMaster.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__